export default __webpack_public_path__ + "static/location-f357e60b518a79228eeb46178d99636c.png";